export type AgendaTimeScale = 15 | 30 | 60 | 120;
export const AgendaTimeScales: AgendaTimeScale[] = [15, 30, 60, 120];
